import React from 'react';
import './PromotionCta.css';
import { useDispatch, useSelector } from 'react-redux';
import { PromotionsService } from '../../../../../../shared/src/services/promotions.service';
import { NativeEventEmitterService } from '../../../../../../shared/src/services/native-event-emitter.service';
import { ltPromotionActionCodesEnum } from '../../../../../../shared/src/enums/promotions.enum';
import { useAsgActions } from '../../../../../../shared/src/hooks/use-asg-actions.hook';
import {
    promotionOrientaionToVerticalTypeEnum,
    verticalTypesToPamGVIDEnum
} from '../../../../../../shared/src/enums/vertical-types.enum';
import {
    GtmEventLocation,
    GtmEventComponent,
    GtmEventClickElement
} from '../../../../../../shared/src/components/google-tag-manager/enums/gtm-event-enum';
import { GtmService } from '../../../../../../shared/src/services/gtm.service';

export const PromotionCta = ({
    ctaText,
    ctaActionObj,
    orientation,
}) => {
    const dispatch = useDispatch();
    const { fillPamGameVerticalID } = useAsgActions();
    const {
        config: {
            isNativeApp,
            isNativeSsoApp,
            mobileOsType,
        },
    } = useSelector(state => state.app);
    const { isLoggedIn } = useSelector((state) => state.player);

    const ctaClickHandler = (e) => {
        if (e.type === 'keydown' && e.key !== 'Enter') {
            return;
        }

        const orientationKey = orientation?.toLowerCase?.();
        const verticalType = promotionOrientaionToVerticalTypeEnum[orientationKey];
        const pamGVID = verticalTypesToPamGVIDEnum[verticalType];

        GtmService.track({
            location: GtmEventLocation.GAME_GRID,
            component: GtmEventComponent.GRID_STRIP,
            click_element: GtmEventClickElement.BUTTON,
            click_action: 'open promotion',
            grid_strip_source: 'promotions',
            game_vertical_id: pamGVID || '',
            game_vertical_type: verticalType || '',
        });

        if (pamGVID) {
            dispatch(fillPamGameVerticalID(pamGVID));
        }

        const isOneOfNativeApps = isNativeApp || isNativeSsoApp;
        if (isOneOfNativeApps) {
            const action = ctaActionObj.name;
            const data = {
                isLoggedIn,
                gameId: action === ltPromotionActionCodesEnum.GAME ? ctaActionObj.target : null,
            };
            NativeEventEmitterService.emit(action, data, mobileOsType);
        } else {
            PromotionsService.execPromotionCta(ctaActionObj, dispatch);
        }
    };

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={ctaClickHandler}
            onKeyDown={ctaClickHandler}
            className="asg-promotion-fold-thumbnail__details-cta"
            dangerouslySetInnerHTML={{ __html: ctaText }}
        />
    );
};
